import { useSelector } from "react-redux";

import { selectHolidayDates } from "./selectors";

// returns ACH holiday dates as "yyyy-MM-dd" strings
export const useHolidays = () => useSelector(selectHolidayDates);
